import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.object.assign.js";
import moment from 'moment';
import { FIB } from '@/config/constants';

var defaultState = function defaultState() {
  return {
    // Consent is opt-in, so we need to default to false.
    consented: false,
    requestingConsent: false
  };
};

var state = defaultState();
var getters = {
  GET_CONSENTED: function GET_CONSENTED(state) {
    return state.consented;
  },
  GET_REQUESTING_CONSENT: function GET_REQUESTING_CONSENT(state) {
    return state.requestingConsent;
  }
};
var mutations = {
  resetState: function resetState(state) {
    Object.assign(state, defaultState());
  },
  SET_CONSENTED: function SET_CONSENTED(state, data) {
    state.consented = data;
  },
  SET_REQUESTING_CONSENT: function SET_REQUESTING_CONSENT(state, data) {
    state.requestingConsent = data;
  }
};
var actions = {
  loadConsent: function loadConsent(_ref) {
    var commit = _ref.commit,
        rootGetters = _ref.rootGetters;

    if (rootGetters['config/isApp']) {
      commit('SET_CONSENTED', true);
      commit('SET_REQUESTING_CONSENT', false);
      return;
    } // Determine if we need to ask for cookie consent on SPA
    // Check if cookie consent has been asked for before, and use that result if it occurred
    // within 90 days.
    //   Why do we store & access this outside of store modules which are held in local storage
    // themselves? Because this codebase has a (slightly unhelpful) method called
    // resetAllModuleStates which will delete all data in localeStorage. We don't have any
    // control over when it's called. Currently it's called on the PWA only but there's nothing
    // stopping it being called in the SPA anyway. We need to track cookie consent between
    // survey sessions, so the safest way to do that is to store it outside of the remit of the
    // store.


    var storedCookieConsent;

    try {
      storedCookieConsent = JSON.parse(window.localStorage.getItem(FIB.LOCAL_STORAGE.COOKIE_CONSENT));
    } catch (e) {
      storedCookieConsent = null;
    } // Merge over defaults


    storedCookieConsent = _objectSpread({
      consented: false,
      timestamp: 0
    }, storedCookieConsent);

    if (moment(storedCookieConsent.timestamp).isSameOrBefore(moment().subtract(90, 'd'))) {
      // If the stored cookie consent is too old or doesn't exist, trash it and request consent
      // again.
      window.localStorage.removeItem(FIB.LOCAL_STORAGE.COOKIE_CONSENT); // Default to false to ensure we're opting-out by default.

      commit('SET_CONSENTED', false);
      commit('SET_REQUESTING_CONSENT', true);
    } else {
      // Use the stored cookie consent.
      commit('SET_CONSENTED', storedCookieConsent.consented);
      commit('SET_REQUESTING_CONSENT', false);
    }
  },
  setConsent: function setConsent(_ref2, consented) {
    var commit = _ref2.commit;
    // Track what's been set as the consent this time, so that we can re-use the consent for
    // later surveys (up to some time limit).
    var stored = {
      consented: consented,
      timestamp: new Date().getTime()
    };
    window.localStorage.setItem(FIB.LOCAL_STORAGE.COOKIE_CONSENT, JSON.stringify(stored));
    commit('SET_CONSENTED', consented);
    commit('SET_REQUESTING_CONSENT', false);
  }
};
export default {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
  namespaced: true
};